import React from "react";
import { Link } from "react-router-dom";
import youtubeImg from "../img/youtube.png";

const SettingRow = ({
  heading,
  para,
  blueLink,
  youtubeLink,
  youtubeLinkURL,
  children,
  backIcon,
  buttonName,
  changeClick
}) => {
  const goBack = () => {
    window.history.back();
  };
  return (
    <>
      {buttonName && (
        <div className="top-btn-container">
          {backIcon === true ? (
            <i className="bi bi-arrow-90deg-left" onClick={goBack}></i>
          ) : (
            <span></span>
          )}
          <button onClick={changeClick}>{buttonName}</button>
        </div>
      )}

      <div className="setting-row">
        <div className="setting-content">
          <h4>{heading}</h4>
          <p>{para}</p>
          {blueLink && (
            <Link to="#" className="blue-link">
              {blueLink} <i className="bi bi-arrow-up-right"></i>
            </Link>
          )}
          {youtubeLink && (
            <Link
              to={youtubeLinkURL}
              className="youtube-link"
              style={{ marginTop: "5px" }}
            >
              <img src={youtubeImg} alt="youtube-icon" />
              youtubeLink
            </Link>
          )}
        </div>
        <div className="setting-box-1">{children}</div>
      </div>
    </>
  );
};

export default SettingRow;
